export enum DataTypeEnum {
  Integer    = '00000054-1000-0000-0000-000000000001',
  String     = '00000054-1000-0000-0000-000000000002',
  Boolean    = '00000054-1000-0000-0000-000000000003',
  DateTime   = '00000054-1000-0000-0000-000000000004'
}
